import { render, staticRenderFns } from "./Auth2faCode.vue?vue&type=template&id=08c08c2e"
import script from "./Auth2faCode.vue?vue&type=script&lang=js"
export * from "./Auth2faCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports